import React, { useEffect, useState } from "react";
import { baseUrl } from '../shared';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ItemView from './itemView'
import Create from './create/createItem'
import Admin from './admin'
import Logout from './logout'
import ResetPassword from './resetPassword'
import OpenBookings from "./openBookings";
import Wallboard from "./wallboard";
import NoPage from './NoPage'
import AppShell from '../components/AppShell'
import './App.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function App() {

  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setOpen(false);
    logOutUser();
  };

  const logOutUser = () => {
    const url = baseUrl + 'user/logout';
fetch(url, {
  method: 'POST',
  headers: {
      'username': localStorage.getItem('username'),
      'bToken': localStorage.getItem('bToken')
  }})
.then((response) => response.json())
.then((data) => {
    console.log('logout',data);
    localStorage.clear();
    window.location.href='/'
})
.catch((err) => {
   console.log(err.message);
});
};

  const checkValidLogin = async () => {
    const url = baseUrl + 'user/validLogin';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
      .then((response) => response.json())
      .then((data) => {
        console.log(data)
        if( data.status === "200") {
          localStorage.setItem("adminFunctions", data.adminFunctions);
          localStorage.setItem("canViewWallboard", data.canViewWallboard);
          if (data.canViewWallboard === 1 && data.adminFunctions !== 1 && window.location.pathname !== '/wallboard') {
            window.location.href = '/wallboard';
          }
        } else if (data.status === 401) {
          setMessage(data.message);
          setOpen(true);
        }
      })
      .catch((err) => {
         console.log(err.message);
      }); 
  }

  useEffect(() => {
    if(localStorage.getItem('username') !== null){
      checkValidLogin()
    }
    }, []);

 return (
  <>
  <React.Fragment>
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="confirmDeleteTitle">
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="confirmDeleteDesc">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
</React.Fragment>
  <Router>
   <AppShell>
     <Routes>
       <Route>
         <Route path="/" exact element={<ItemView />} />
         <Route path="createItem" element={<Create />} />
         <Route path="admin" element={<Admin />} />
         <Route path="logout" element={<Logout />} />
         <Route path="resetPassword" element={<ResetPassword />} />
         <Route path="openBookings" element={<OpenBookings />} />
         <Route path="wallboard" element={<Wallboard />} />
         <Route path="*" element={<NoPage />} />
       </Route>
     </Routes>
   </AppShell>
 </Router>
</>
 )
}

export default App